var path = 'areas/projects/channels/channel_create.html';
var html = "<script octo-section=breadcrumb type=text/ng-template> <li><a href='#/projects/{{ project.Slug }}/channels/create'>Create New</a></li> </script> <channel-editor></channel-editor> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/channels/channel_create.html
// module id = 3904868687818147
// module chunks = 1